import { render, staticRenderFns } from "./PreRecordControl.vue?vue&type=template&id=6f6954e4&scoped=true&"
import script from "./PreRecordControl.vue?vue&type=script&lang=js&"
export * from "./PreRecordControl.vue?vue&type=script&lang=js&"
import style0 from "./PreRecordControl.vue?vue&type=style&index=0&id=6f6954e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6954e4",
  null
  
)

export default component.exports